import { render, staticRenderFns } from "./paymentCopy.vue?vue&type=template&id=cfd830ba"
import script from "./paymentCopy.vue?vue&type=script&lang=js"
export * from "./paymentCopy.vue?vue&type=script&lang=js"
import style0 from "./paymentCopy.vue?vue&type=style&index=0&id=cfd830ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports